import {
  ADD_PRESCRIPTION,
  GET_MEDICINE_INVENTORY,
  GET_PRESCRIPTIONS,
  MEDICINE_INVENTORY_ERROR,
  DOWNLOAD_PRESCRIPTION,
} from "./PrescriptionActions";

const initialState = {
  prescriptions: [],
  prescription: null,
  medicineInventory: [],
  inventoryError: null,
  searchQuery: "",
  downloadedPrescriptionUrl: null,
};

const PrescriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRESCRIPTIONS:
      return {
        ...state,
        prescriptions: action.prescriptions,
      };

    case ADD_PRESCRIPTION:
      return {
        ...state,
        prescription: action.prescription,
      };

    case GET_MEDICINE_INVENTORY:
      return {
        ...state,
        medicineInventory: action.medicineInventory,
        inventoryError: null,
      };

    case MEDICINE_INVENTORY_ERROR:
      return {
        ...state,
        medicineInventory: [],
        inventoryError: action.error,
      };

    case DOWNLOAD_PRESCRIPTION:
      return {
        ...state,
        downloadedPrescriptionUrl: action.fileUrl,
      };

    default:
      return state;
  }
};

export default PrescriptionReducer;
